export var BillingProvider;
(function (BillingProvider) {
    BillingProvider["BILLING_PROVIDER_UNSPECIFIED"] = "BILLING_PROVIDER_UNSPECIFIED";
    BillingProvider["BILLING_AWS"] = "BILLING_AWS";
    BillingProvider["BILLING_AZURE"] = "BILLING_AZURE";
    BillingProvider["BILLING_GCP"] = "BILLING_GCP";
    BillingProvider["BILLING_DIRECT"] = "BILLING_DIRECT";
})(BillingProvider || (BillingProvider = {}));
